/* Banner-designer: steg-for-steg på mobil (Festkompaniet). Legger seg oppå br-designer.js uten å endre logikken.
   Aktiv på skjermer ≤ 900 px, eller med ?steg=1 i adressen (test på PC). */
(function () {
  if (!window.matchMedia('(max-width: 900px)').matches && !/[?&]steg=1/.test(location.search)) return;
  var $ = function (id) { return document.getElementById(id); };
  var css = ''
    + '.brs .br-grid{display:block}'
    + '.brs .br-prevbox{position:sticky;top:0;z-index:15;background:#fff;margin:0 -16px 6px;padding:10px 16px 8px;box-shadow:0 6px 14px rgba(0,0,0,.08)}'
    + '.brs .br-prev.portrait{width:calc(150px / var(--ar,3.25))!important;margin:0 auto}'
    + '.brs .br-cap{margin:6px 0 0;font-size:12px}'
    + '.brs-zoom{position:absolute;right:22px;top:16px;width:36px;height:36px;border-radius:50%;border:0;background:rgba(255,255,255,.95);box-shadow:0 1px 5px rgba(0,0,0,.25);display:flex;align-items:center;justify-content:center;cursor:pointer;padding:0}'
    + '.brs-kicker{display:block;font-size:13px;font-weight:700;color:#7b33e6;letter-spacing:.02em;margin-top:6px}'
    + '.brs-bar{display:flex;gap:6px;margin:6px 0 4px}.brs-bar i{flex:1;height:5px;border-radius:3px;background:#e9e3f7}.brs-bar i.on{background:#7b33e6}'
    + '.brs-title{font-size:22px;line-height:1.25;font-weight:700;margin:8px 0 4px;color:var(--ink)}'
    + '.brs-step .br-label{margin:16px 0 8px}'
    + '.brs #br-dbox>.br-label:first-child,.brs #br-std>.br-label:first-child,.brs #br-own>.br-label:first-child,.brs-step>.br-label:first-child{display:none}'
    + '.brs-nav{position:sticky;bottom:0;z-index:20;background:#fff;display:flex;gap:10px;padding:12px 0 calc(12px + env(safe-area-inset-bottom,0px));margin-top:18px;border-top:1px solid #eee7dc}'
    + '.brs-nav button{height:54px;border-radius:12px;font:inherit;font-size:17px;font-weight:700;cursor:pointer}'
    + '.brs-next{flex:1;border:0;background:#7b33e6;color:#fff}'
    + '.brs-back{padding:0 18px;border:1.5px solid #d6d0c6;background:#fff;color:#2d3748}'
    + '.brs-msg{color:#c53030;font-size:14px;font-weight:600;margin:10px 0 0}'
    + '.brs-skip{display:block;width:100%;height:50px;margin-top:14px;border-radius:12px;border:1.5px solid #7b33e6;background:#fff;color:#7b33e6;font:inherit;font-size:16px;font-weight:700;cursor:pointer}'
    + '.brs .br-upload{border:0;padding:0;background:none;margin-top:6px}'
    + '.brs #br-ofile,.brs #br-file{display:block;width:100%;font-size:16px;padding:12px;border:2px dashed #b9a2ec;border-radius:14px;background:#faf7ff;color:#4a5568}'
    + '.brs #br-ofile::file-selector-button,.brs #br-file::file-selector-button{display:block;width:100%;margin:0 0 8px;padding:18px;font:inherit;font-size:18px;font-weight:700;color:#fff;background:#7b33e6;border:0;border-radius:10px}'
    + '.brs #br-ofile::-webkit-file-upload-button,.brs #br-file::-webkit-file-upload-button{display:block;width:100%;margin:0 0 8px;padding:18px;font:inherit;font-size:18px;font-weight:700;color:#fff;background:#7b33e6;border:0;border-radius:10px}'
    + '.brs #br-add{height:56px;border-radius:12px;font-size:18px;font-weight:700}'
    + '.brs-ov{position:fixed;inset:0;z-index:2147483000;background:rgba(20,16,24,.85);display:flex;align-items:center;justify-content:center;padding:20px;cursor:zoom-out}'
    + '.brs-ov svg{display:block;max-width:94vw;max-height:84vh;width:auto;height:auto;background:#fff;border-radius:4px}'
    + '.brs-ov .x{position:absolute;top:12px;right:16px;color:#fff;font-size:34px;line-height:1;background:none;border:0}';

  function init(tries) {
    var fields = document.querySelector('.br-fields'), prevbox = document.querySelector('.br-prevbox'), add = $('br-add');
    if (!fields || !prevbox || !add || !document.querySelector('.br-ok') || !$('br-prev').firstChild) {
      if ((tries || 0) < 80) setTimeout(function () { init((tries || 0) + 1); }, 100);
      return;
    }
    var st = document.createElement('style'); st.textContent = css; document.head.appendChild(st);
    $('br-root').classList.add('brs');

    var vis = function (el) { return !!el && !el.hidden && getComputedStyle(el).display !== 'none'; };
    var own = function () { return !$('br-own').hidden; };
    var uploaded = function () { var a = $('br-oadjust'); return !!a && !a.hidden; };
    var variants = $('br-variants'), sizeLabel = variants.previousElementSibling;
    var photoYN = $('br-photoyn'), photoLabel = photoYN.previousElementSibling, upload = $('br-upload');
    var hasPhoto = vis(photoYN);
    var multiDesign = vis($('br-dbox'));
    var multiSize = variants.children.length > 1;

    function box(nodes) { var d = document.createElement('div'); d.className = 'brs-step'; nodes.forEach(function (n) { if (n) d.appendChild(n); }); return d; }
    var photoBox = box([photoLabel, photoYN, upload]);
    var skip = document.createElement('button'); skip.type = 'button'; skip.className = 'brs-skip'; skip.textContent = 'Hopp over – uten bilde';
    photoBox.appendChild(skip);

    var steps = [
      { el: box([$('br-dbox'), sizeLabel, variants]), on: function () { return multiDesign || multiSize; },
        title: function () { return multiDesign ? (multiSize ? 'Velg design og størrelse' : 'Velg design') : 'Hvilken vei skal banneret henge?'; } },
      { el: box([$('br-std'), $('br-own')]), on: function () { return true; },
        title: function () { return own() ? 'Last opp designet ditt' : 'Skriv teksten'; },
        check: function () {
          if (own()) return uploaded() ? '' : 'Last opp filen din for å gå videre.';
          if (!$('br-l1').value.trim() && !$('br-l2').value.trim()) return 'Skriv inn teksten din for å gå videre.';
          if (document.querySelector('.br-count.over')) return 'Teksten er for lang for denne størrelsen.';
          return '';
        } },
      { el: photoBox, on: function () { return hasPhoto && !own(); }, title: function () { return 'Vil du ha et bilde på banneret?'; } },
      { el: box([$('br-opt2box'), document.querySelector('.br-ok'), add, $('br-err'), $('br-note')]), on: function () { return true; },
        title: function () { return own() ? 'Se over og bestill' : 'Slik blir banneret ditt'; } }
    ];

    var head = document.createElement('div');
    head.innerHTML = '<span class="brs-kicker"></span><div class="brs-bar"></div><h3 class="brs-title"></h3>';
    var wrap = document.createElement('div');
    var nav = document.createElement('div'); nav.className = 'brs-nav';
    nav.innerHTML = '<button type="button" class="brs-back">Tilbake</button><button type="button" class="brs-next">Neste</button>';
    var msg = document.createElement('p'); msg.className = 'brs-msg'; msg.hidden = true;
    fields.insertBefore(head, fields.firstChild);
    fields.appendChild(wrap);
    steps.forEach(function (s) { wrap.appendChild(s.el); });
    fields.appendChild(msg); fields.appendChild(nav);

    var zb = document.createElement('button'); zb.type = 'button'; zb.className = 'brs-zoom'; zb.setAttribute('aria-label', 'Se større');
    zb.innerHTML = '<svg aria-hidden="true" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="#2d3748" stroke-width="2.2" stroke-linecap="round"><circle cx="10.5" cy="10.5" r="6.5"/><path d="M15.5 15.5L21 21"/></svg>';
    prevbox.appendChild(zb);
    zb.addEventListener('click', function () {
      var o = document.createElement('div'); o.className = 'brs-ov';
      o.innerHTML = $('br-prev').innerHTML + '<button type="button" class="x" aria-label="Lukk">×</button>';
      o.addEventListener('click', function () { o.remove(); });
      document.body.appendChild(o);
    });

    var cur = 0;
    function active() { return steps.filter(function (s) { return s.on(); }); }
    function show(s, scroll) {
      var list = active(); if (list.indexOf(s) < 0) s = list[0];
      cur = steps.indexOf(s);
      steps.forEach(function (x) { x.el.hidden = x !== s; });
      var i = list.indexOf(s), n = list.length;
      head.querySelector('.brs-kicker').textContent = 'STEG ' + (i + 1) + ' AV ' + n + (s === steps[2] ? ' · VALGFRITT' : '');
      head.querySelector('.brs-bar').innerHTML = list.map(function (x, k) { return '<i' + (k <= i ? ' class="on"' : '') + '></i>'; }).join('');
      head.querySelector('.brs-title').textContent = s.title();
      nav.querySelector('.brs-back').style.display = i === 0 ? 'none' : '';
      nav.querySelector('.brs-next').style.display = i === n - 1 ? 'none' : '';
      nav.querySelector('.brs-next').textContent = i === n - 2 ? 'Neste: se og bestill' : 'Neste';
      prevbox.style.display = (own() && !uploaded()) ? 'none' : '';
      msg.hidden = true;
      if (scroll) { var t = $('br-title'); window.scrollTo({ top: t.getBoundingClientRect().top + window.scrollY - 8, behavior: 'smooth' }); }
    }
    function go(d) {
      var list = active(), i = list.indexOf(steps[cur]);
      if (d > 0 && steps[cur].check) { var e = steps[cur].check(); if (e) { msg.textContent = e; msg.hidden = false; return; } }
      var j = Math.max(0, Math.min(list.length - 1, i + d));
      show(list[j], true);
    }
    nav.querySelector('.brs-next').addEventListener('click', function () { go(1); });
    nav.querySelector('.brs-back').addEventListener('click', function () { go(-1); });
    skip.addEventListener('click', function () { var no = photoYN.querySelector('[data-v="0"]'); if (no) no.click(); go(1); });
    // når kunden bytter design (f.eks. til «Egen fil») kan stegene endre seg
    $('br-designs').addEventListener('click', function () { setTimeout(function () { show(steps[cur], false); }, 30); });
    $('br-ofile').addEventListener('change', function () { setTimeout(function () { show(steps[cur], false); }, 400); });
    show(steps[0], false);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(0); }); else init(0);
})();